import {
    SITE_SETTINGS_SUCCESS
} from '../constants/index'

const initialState = {
    data: {}
};

export default function user(state = initialState, action) {
    switch(action.type) {
        case SITE_SETTINGS_SUCCESS:
            return {
                ...state,
                data: action.data
            }

        default:
            return {
              ...state
            };
    }
};
  
